import React from 'react'
const Honeypot = () => {
  return (
    <>
      <form id='myformid' action='/myformaction'>
        <label
          htmlFor='email'
          style={{
            opacity: `0`,
            position: `absolute`,
            top: `0`,
            left: `0`,
            height: `0`,
            width: `0`,
            zIndex: `-1`,
          }}
        ></label>
        <input
          style={{
            opacity: `0`,
            position: `absolute`,
            top: `0`,
            left: `0`,
            height: `0`,
            width: `0`,
            zIndex: `-1`,
          }}
          autoComplete='off'
          type='text'
          id='username'
          name='email'
          placeholder='Registration Email'
        />
        <label
          htmlFor='password'
          style={{
            opacity: `0`,
            position: `absolute`,
            top: `0`,
            left: `0`,
            height: `0`,
            width: `0`,
            zIndex: `-1`,
          }}
        ></label>
        <input
          style={{
            opacity: `0`,
            position: `absolute`,
            top: `0`,
            left: `0`,
            height: `0`,
            width: `0`,
            zIndex: `-1`,
          }}
          autoComplete='off'
          type='password'
          id='password'
          name='password'
          placeholder='User password'
        />
      </form>
    </>
  )
}

export default Honeypot
